import GenericObject from '@/Model/GenericObject';
import Factory from '@/Factories/Factory';
import SummaryViewFactoryTuple from '@/Factories/SummaryViewFactoryTuple';
import * as interfaces from '#/CoreFrameInterfaces';
import {DisposeBehavior} from '#/DefaultViewExtensionInterfaces';

/**
* Repräsentiert die Oberklasse aller SummaryViewFactories
*/
export default class SummaryViewFactory extends Factory {

    /**
    * Das GenericObject der SummaryView
    */
    public genericObject: GenericObject;

    /**
     * Die PdoId des Objekts
     */
    public pdoId: string;

    /**
     * Der Typ des Objekts
     */
    public pdTypeName: string;

    /**
     * Der ergonomische Bezeichner der Listview
     */
    public ergName: string;

    /**
     * Gibt an, ob die SummaryView immer sichtbar ist
     */
    public showAlways: boolean;

    /**
     * Gibt an, ob ein DropDown für die historisierten Elemente angezeigt werden soll
     */
    public showHistory: boolean;

    /**
     * Definiert den Bereich in der die SummaryView angezeigt wird
     */
    public orientation: string;

    /**
     * Definiert den Bereich in der die SummaryView angezeigt wird
     */
    public screenRatio: number;

    public tuple: SummaryViewFactoryTuple;

    constructor(params: interfaces.ISummaryViewFactoryConstructorParameter) {
        super(params);

        this.genericObject = this.paramOrDefault(params.genericObject, null);
        this.pdoId = this.paramOrDefault(params.pdoId, null);
        this.pdTypeName = this.paramOrDefault(params.pdTypeName, null);
        this.ergName = this.paramOrDefault(params.ergName, null);
        this.showAlways = this.paramOrDefault(params.showAlways === true, false);
        this.showHistory = this.paramOrDefault(params.showHistory === true, false);
        this.orientation = this.paramOrDefault(params.orientation, 'Horizontal');
        this.screenRatio = this.paramOrDefault(params.screenRatio, 50);
        this.isDisposable = true;
    }

    /**
    * Erzeugt das FactoryTuple und die Factory
    */
    public getTuple() {
        const $view = this.getSummaryView();
        this.tuple = new SummaryViewFactoryTuple(this, $view);
        return this.tuple;
    }

    public getSummaryView(): JQuery<HTMLElement> {
        throw new Error('Die Funktion "getSummaryView" wurde nicht implementiert');
    }

    protected getDisposeBehavior(): DisposeBehavior {
        return "Asynchronous";
    }
}